import { useNavigate } from "react-router-dom";
import { AdminButton } from "../../../../../SharedComponents/ListView";

/**
 * disabledReason: tooltip explaining why the button is disabled. A disabled <button>
 * swallows mouse events in most browsers, so a title on the button itself never shows —
 * the tooltip lives on a focusable wrapper instead (also reachable by keyboard).
 */
export default function NavigateButton({ path, application, children, disabled, disabledReason }) {
  const navigate = useNavigate();

  const handleNavigate = () => navigate(path, { state: application });
  const explainDisabled = disabled && disabledReason;

  const button = (
    <AdminButton
      variant="primary"
      onClick={handleNavigate}
      disabled={disabled}
      style={explainDisabled ? { pointerEvents: "none" } : undefined}
    >
      {children}
    </AdminButton>
  );

  if (!explainDisabled) return button;

  return (
    <span className="d-inline-block" title={disabledReason} tabIndex={0}>
      {button}
    </span>
  );
}
